import { createFileRoute } from '@tanstack/react-router';
import { NoticiasPage } from '@/features/noticias/pages/noticias-page';

export const Route = createFileRoute('/_public/noticias')({
  component: NoticiasPage,
});
